// import ProductService from '@/services/ProductService.js'
// export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

import InvoiceService from "@/services/InvoiceService"
import Vue from 'vue'

export const state = {
}

export const mutations = {
}

export const actions = {
  addInvoice({ dispatch }, invoiceBody) {
    return InvoiceService.insertInvoice(invoiceBody)
        .then((invoice) => {
            const notification = {
                type: 'success',
                message: 'Your invoice has been added successfully!'
            }
            dispatch('notification/add', notification, { root: true })
            return invoice.data
        })
        .catch(error => {
            const notification = {
                type: 'error',
                message: 'There was a problem adding your invoice data: ' + error.message
            }
            Vue.notify({
                group: 'main',
                type: 'error',
                text: "We can't process your request at this time"
            });
            dispatch('notification/add', notification, { root: true })
            // throw error
        })
  }
}

export const getters = {}
